import React, { useState } from 'react';
import moment from 'moment';
import { MenuPopup } from '@prosolve/common-components-ui'
import { FaPlane, FaEllipsisH } from "react-icons/fa";
import { checkHasEditEventPermissions, checkHasEventTrainerPermissions } from '../../../../../utils';
import useIsMobileView from "../../../../../hooks/useIsMobileView";

const LabelValue = ({ label = '', value = '', wrapperStyle = {}, labelStyle = {}, valueStyle = {}}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      ...wrapperStyle
    }}>
      <div style={{ color: '#565656', marginBottom: '5px', ...labelStyle }}>{label}</div>
      <div style={{ ...valueStyle }}>{value}</div>
    </div>
  )
}

export default ({
  flightGroupData = {},
  flightData = {},
  onEditFlight,
  onDeleteFlight
}) => {
  const isMobileView = useIsMobileView();

  const hasEditPermissions = ( checkHasEditEventPermissions() || checkHasEventTrainerPermissions() );

  const title = flightData.flightType === 'Departing' ? 'Depart' : 'Return';

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const onMenuSelection = (val) => {
    if (val === 'Edit') {
      onEditFlight(flightGroupData)
    } else if (val === 'Delete') {
      onDeleteFlight(flightGroupData)
    }
  }

  return (
    <div style={{ 
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
      border: '1px solid #c4c4c4',
      borderRadius: '10px'
    }}>
      <div style={{ 
        display: 'flex',
        position: 'relative',
        justifyContent: 'space-between',
        marginBottom: '20px'
      }}>
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: isMobileView ? 'column' : 'row',
          gap: '10px',
          justifyContent: 'space-between',
        }}>
          <LabelValue label={title} value={flightData.takeOff ? moment(flightData.takeOff).format('ddd, MMMM DD, YYYY') : ''} />
          <LabelValue label='Flight' value={`${flightData.airline} ${flightData.airlineFlightNumber}`} />
          <LabelValue label='Confirmation No.' value={flightData.flightConfirmation} />
        </div>
        {
          hasEditPermissions &&
          <div style={{ position: 'relative', top: '0px', right: '0px' }}>
            <FaEllipsisH
              style={{ color: '#7e7e7e', padding: '10px', cursor: 'pointer', marginLeft: '20px' }}
              onClick={(e) => { e.stopPropagation(); setIsMenuOpen(true) }}
            />
            <MenuPopup
              open={isMenuOpen}
              top='30px'
              left='-50px'
              options={['Edit', 'Delete']}
              onClose={() => setIsMenuOpen(false)}
              onSelection={(val) => onMenuSelection(val)}
            />
          </div>
        }
      </div>
      <div style={{ 
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px'
      }}>
        <LabelValue 
          label={flightData.takeOffTime ? moment(flightData.takeOffTime, 'HH:mm:ss').format('h:mm A') : ''}
          labelStyle={{ fontSize: '15px' }}
          value={flightData.takeOffCity}
          valueStyle={{ fontSize: '18px' }}
        />
        <FaPlane style={{ padding: '0px 20px', color: '#0280c6', fontSize: '20px' }} />
        <LabelValue 
          label={flightData.landingTime ? moment(flightData.landingTime, 'HH:mm:ss').format('h:mm A') : ''}
          labelStyle={{ fontSize: '15px' }}
          value={flightData.landingCity}
          valueStyle={{ fontSize: '18px' }}
        />
      </div>
      <div style={{ 
        display: 'flex',
      }}>
        <LabelValue label='Name(s)' value={flightData.personFlying} />
      </div>
    </div>
  );
};
